var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.caption)?_c('div',{class:_vm.htmlClass},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.getCaptionText())+" ")],{"caption":_vm.caption,"text":_vm.getCaptionText()})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }